import { InertiaLinkProps } from '@inertiajs/react';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function isSameUrl(
    url1: InertiaLinkProps['href'] | undefined,
    url2: InertiaLinkProps['href'] | undefined,
) {
    return resolveUrl(url1) === resolveUrl(url2);
}

export function resolveUrl(url: InertiaLinkProps['href'] | undefined): string {
    if (url === undefined || url === null) {
        return '';
    }
    return typeof url === 'string' ? url : url.url;
}
